import React, { useState, useEffect } from 'react'
import { Col, Panel, Row } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import ButtonPanelWidget from '../ButtonPanelWidget'
import { startLoading, doneLoading } from '../../utils/loading'
import DisbursementToForm from './DisbursementToForm'
import ReimbursementForm from './ReimbursementForm'
import BookProjectBudgetForm from './BookProjectBudgetForm'

export default function FinancialManagementWidget(props) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [voucherSchema, setVoucherSchema] = useState()
  const [dataTable, setDataTable] = useState(props.schema.form)
  const [formDisplayLists, setFormDisplayLists] = useState()

  return (
    <>
      <Panel shaded collapsible defaultExpanded header={'เบิกงวดเงิน'} bordered>
        <DisbursementToForm
          schema={formSchema?.form?.DisbursementForm}
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          getValues={getValues}
          setValue={setValue}
          clearErrors={clearErrors}
        />
      </Panel>

      <Panel shaded collapsible defaultExpanded header={'เบิกค่าทบทวน'} style={{ marginTop: 10 }}>
        <ReimbursementForm
          schema={formSchema?.form?.ReimbursementForm}
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          getValues={getValues}
          setValue={setValue}
          clearErrors={clearErrors}
        />
      </Panel>

      <Panel shaded collapsible defaultExpanded header={'จองงบโครงการ'} style={{ marginTop: 10 }}>
        <BookProjectBudgetForm
          schema={formSchema?.form?.BookProjectBudgetForm}
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          getValues={getValues}
          setValue={setValue}
          clearErrors={clearErrors}
        />
      </Panel>
    </>
  )
}
